<template>
  <div>
    <el-upload
      :accept="accept"
      :action="CONFIG.ACTION_URL"
      :file-list="uploadFileList"
      :data="uploadParmas"
      :auto-upload="false"
      :show-file-list="true"
      :limit="max"
      :multiple="multiple"
      :on-change="onImageUploadChange"
      ref="uploadFiles"
      :on-preview="handlePreview"
      :on-remove="handleRemove"
      :disabled="disabled"
      :class="{
        'hide-upload-button': !isShow,
      }"
    >
      <el-button
        size="medium"
        type="primary"
        icon="el-icon-upload"
        v-if="isShow"
        >点击上传</el-button
      >
      <div slot="tip" class="el-upload__tip light-gray-color" v-if="isShow">
        {{ computedTips }}
      </div>
    </el-upload>
  </div>
</template>

<script>
import * as CONFIG from "@/config";
import * as fileUtil from "@/common/file";

export default {
  props: {
    max: {
      type: Number,
    },
    min: {
      type: Number,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    accept: {
      type: String,
      default: ".doc,.docx,.pdf,.xls,.xlsx",
    },
    isShow: {
      type: Boolean,
      default: true,
    },
    multiple: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      CONFIG: Object.freeze(CONFIG),
      uploadParmas: {
        // 授权码，不能改！！！！！
        token: CONFIG.UPLOAD_TOKEN,
        key: "",
      },
      uploadFileList: [],
      // { name:名称, url:路径 }
    };
  },
  computed: {
    computedTips() {
      const tempArr = [`支持${this.accept}格式，单个文件大小不超过10MB`];
      if (this.min) {
        tempArr.push(`至少上传${this.min}个文件`);
      }
      if (this.max) {
        tempArr.push(`最多上传${this.max}个文件`);
      }
      return tempArr.join("；");
    },
  },
  methods: {
    // 回显父组件传过来的文件
    initFileList(fileList) {
      this.uploadFileList = fileList || [];
    },
    //处理图片上传
    onImageUploadChange(file, fileList) {
      file.url = URL.createObjectURL(file.raw);
      this.uploadFileList = fileList;
      let reader = new FileReader();
      reader.readAsArrayBuffer(file.raw);
      reader.onload = () => {
        this.uploadParmas.key = fileUtil.getUploadPath(
          file.name,
          reader.result
        );
        this.$refs.uploadFiles.submit();
      };
    },

    // 上传文件预览事件
    handlePreview(file) {
      window.open(file.url);
    },
    // 上传文件删除按钮事件
    handleRemove(file, fileList) {
      this.uploadFileList = fileList;
    },
    // 重置
    reset() {
      this.$refs.uploadFiles.clearFiles();
      this.uploadFileList = [];
    },

    // 校验方法
    getData() {
      const hasUploadingFiles = this.uploadFileList.some(
        (item) => item.status === "uploading"
      );
      if (hasUploadingFiles) {
        this.$message.warning("请等待文件上传完毕");
        return false;
      }
      if (this.min && this.uploadFileList.length < this.min) {
        this.$message.warning(`至少上传${this.min}个文件`);
        return false;
      }

      return getUploadFileArr(this.uploadFileList);

      // 处理文件对象
      function getUploadFileArr(files) {
        return files.map((item) => {
          return {
            name: item.name,
            url: getItemUrl(item),
          };
        });
      }

      // 校验返回的url是否以http开头
      function getItemUrl(item) {
        if (item.url && item.url.startsWith("http")) {
          return item.url;
        } else {
          return fileUtil.getUploadedFileUrl(item.response.key);
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.hide-upload-button {
  ::v-deep .el-upload {
    display: none !important;
  }
}
</style>
